import React, { useState } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import moment from "moment";
import { useEffect } from "react";
import $ from "jquery";
import { minDate } from "../../Constants/Constants";

const UpdateMaterialModal = ({
  getData,
  selectedRowsData,
  updateHandleChange,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  // console.log("selectedRowsData", selectedRowsData.company.company_name)
  const companyName = selectedRowsData.companyDetails?.company_name || "";
  const materialName = selectedRowsData.rawMaterialName?.material_name || "";
  const selectedCompanyId = selectedRowsData.companyDetails?.id || "";
  const selectedMaterialId = selectedRowsData.rawMaterialName?.id || "";
  const [date, setDate] = useState(null);

  useEffect(() => {
    // console.log(selectedRowsData.date)
    setDate(
      selectedRowsData.date &&
        moment(selectedRowsData.date,"DD-MM-YYYY").format("yyyy-MM-DD")
    );
  }, [selectedRowsData]);
  // const companyName = selectedRowsData.company.company_name
  // console.log("selectedCompanyId", selectedCompanyId);

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  const updateData = async (e) => {
    e.preventDefault();
    const {
      id,
      over_stock,
      shortage_stock,
      damage_stock,
      date,
      company_id,
      material_name_id,
    } = selectedRowsData;
    // const renewalDate = moment.utc(selectedRowsData.date).format("YYYY-MM-DD");
    // const formattedDate = moment.utc(date, "YYYY-MM-DD").toISOString();
    let BASE_URL = SERVER_URL + `/api/raw-mat/raw-material-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        over_stock,
        shortage_stock,
        damage_stock,
        company_id:selectedCompanyId,
        material_name_id:selectedMaterialId,
        date: date,
      
      }),
    });
    const response = await res.json();
    if (res.ok) {
      closeModal();
      setTimeout(() => {
        toast.success(response.message);
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="updateModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
            <h5 className="modal-title" id="imageZoomModalTitle">
                Update Raw Material Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Update Raw Material Details</h4> */}
                    <form className="form-sample">
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="over_stock">Over stock</label>
                            <input
                              type="text"
                              className="form-control"
                              name="over_stock"
                              id="over_stock"
                              placeholder="Over stock"
                              value={selectedRowsData?.over_stock}
                                onChange={updateHandleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="shortage_stock">Shortage stock</label>
                            <input
                              type="text"
                              className="form-control"
                              name="shortage_stock"
                              id="shortage_stock"
                              placeholder="Shortage stock"
                              value={selectedRowsData?.shortage_stock}
                                onChange={updateHandleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="damage_stock">Damage stock</label>
                            <input
                              type="text"
                              className="form-control"
                              name="damage_stock"
                              id="damage_stock"
                              placeholder="Damage stock"
                              value={selectedRowsData?.damage_stock}

                                onChange={updateHandleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                      <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Date">Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="date"
                              id="Date"
                              value={date}
                              readOnly
                              min={minDate}
                            />
                          </div>
                        </div>
                      <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="material">Material Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="material_name"
                              id="material"
                              value={materialName}
                              readOnly
                              //   onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="company">Company Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="company_name"
                              id="company"
                              placeholder="Company Name"
                              value={companyName}
                              readOnly
                              //   onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        onClick={updateData}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateMaterialModal;
